import classnames from "classnames"
import { LEARN, TEACH } from "path/constants"
import { ALLOW_RESETS } from "step/constants"
import StepCompleted from "./StepCompleted"
import StepCompletionError from "./StepCompletionError"
import StepIncomplete from "./StepIncomplete"
import "./styles/StepCompletion.css"

const StepCompletion = function (props) {
  const {
    mode,
    step,
    completion,
    is_completing_step,
    step_completion_error,
    is_reseting_completion,
    permissions,
    completions_url,
    content
  } = props
  const {
    progress,
    is_disabled,
    is_skipped,
    has_failed_passing_attempt,
    minimum_passing_score,
    last_completion_attempt_date,
    allow_resets
  } = completion
  const { can_facilitate, can_edit } = permissions

  const completed = progress >= 1

  const className = classnames("path-step-completion-view", {
    "path-step-completion-incomplete": !completed,
    "path-step-completion-disabled": is_disabled,
    "path-step-completion-completed": completed && !is_skipped,
    "path-step-completion-skipped": completed && is_skipped
  })

  const failed =
    mode <= LEARN &&
    has_failed_passing_attempt &&
    allow_resets === ALLOW_RESETS.BEFORE &&
    (!content || content.type === "blocks")

  const showCompletion = [LEARN, TEACH].includes(mode)

  return (
    <div className="StepCompletion">
      {showCompletion ? (
        <div className={className}>
          {step_completion_error || has_failed_passing_attempt ? (
            <StepCompletionError
              {...Object.assign({}, props)}
              completionIsDisabled={failed}
            />
          ) : undefined}
          {progress < 1 ? (
            <StepIncomplete
              {...Object.assign({}, props)}
              canComplete={failed ? false : props.canComplete}
              failed={failed}
            />
          ) : (
            <StepCompleted {...Object.assign({}, props)} />
          )}
        </div>
      ) : undefined}
    </div>
  )
}

StepCompletion.displayName = "StepCompletion"

export default StepCompletion
